
const { NIMBUS_DATA_TYPES } = require('../nimbus-data-types');

module.exports = {
  displayName: 'Avoid Manual Material Invoice Update',
  description: 'Using this on the front-end. Something to do with material addition. Used for material file upload',
  sortOrder: 1,
  name: 'avoidManualMaterialInvoiceUpdate',
  documentKey: 'avoid_manual_material_invoice_update',
  values: {
    avoid_manual_material_invoice_update: {
      dataType: NIMBUS_DATA_TYPES.BOOLEAN,
      defaultValue: false,
      displayName: 'Avoid Manual Material Invoice Update',
      documentKey: 'avoid_manual_material_invoice_update',
    },
  },
};
